import { useEffect } from "react";
import { useProfile } from "../components/Hooks/UserHooks";

import authApi from "api/authApi";
import { useDispatch } from "react-redux";
import { loginSuccess } from "store/auth/login/reducer";
import { useToken } from "context/tokenContext";
import { Navigate } from "react-router-dom";
import { useConnectWebSocket } from "components/Hooks/ws/useConnectWebSocket";
import { useRealtimeTrade } from "components/Hooks/ws/useRealtimeTrade";

const AuthProtected = (props: any) => {
  const { userProfile, loading } = useProfile();
  const dispatch: any = useDispatch();

  const { isConnected, error, connect, disconnect } = useConnectWebSocket();

  /*
    Navigate is un-auth access protected routes via url
    */
  const currentUrl = window.location.pathname + window.location.search; // Get the current URL
  localStorage.setItem("referralUrl", currentUrl);
  if (!userProfile && loading) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const resProfile = async () => {
      try {
        const [resProfile, resPermissions]: any = await Promise.all([
          authApi.profile(),
          authApi.myPermissions(),
        ]);
        if (resProfile?.data) {
          const finalLogin = {
            ...userProfile,
            user: {
              ...userProfile?.user,
              ...resProfile?.data,
              permissions: resPermissions?.data || [],
            },
          };
          localStorage.setItem("authUser", JSON.stringify(finalLogin));
          dispatch(loginSuccess(finalLogin));
        }
      } catch (error: any) {
        return error;
      }
    };
    // resProfile();

    return () => {
      disconnect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  return <>{props.children}</>;
};

export default AuthProtected;
